import { rustoreUrl } from '@/lib/appStores'
import { cn } from '@/lib/utils'

/**
 * Официальная кнопка «Скачайте из RuStore».
 *
 * Картинка — фирменная, без перерисовки: `public/badges/rustore.svg` взят
 * как есть со страницы правил кнопки RuStore (тёмный цветной вариант —
 * на светлом фоне сайта он читается лучше светлого). Размер задаётся
 * высотой, пропорции 111 × 40 сохраняются.
 */
export function RuStoreBadge({
  height = 48,
  eager = false,
  referrer,
  className,
  onClick,
}: {
  height?: number
  /** На первом экране кнопка — главное действие: грузить сразу, а не при прокрутке. */
  eager?: boolean
  /** Код приглашения: магазин запомнит его и отдаст приложению после установки. */
  referrer?: string | undefined
  className?: string
  onClick?: () => void
}) {
  return (
    <a
      href={rustoreUrl(referrer)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      aria-label="Скачать приложение LightChat для Android из RuStore"
      className={cn(
        'inline-flex shrink-0 rounded-[10px] transition-opacity hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
        className,
      )}
    >
      <img
        src="/badges/rustore.svg"
        alt="Скачайте из RuStore"
        width={Math.round((height * 111) / 40)}
        height={height}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
      />
    </a>
  )
}
